import { useEffect, useRef } from "react";
import { usePostHog } from "posthog-js/react";
import { useSearchParams } from "react-router-dom";

export const QueryParamTracker = () => {
  const posthog = usePostHog();
  const [searchParams] = useSearchParams();
  const hasRegistered = useRef(false);

  useEffect(() => {
    // Prevent double registration
    if (hasRegistered.current) return;

    // List of custom keys you want to track specifically
    const paramsToTrack = [
      "ref_id",
      "promo_code",
      "onboarding_variant",
      "referrer",
    ];
    const propertiesToRegister: Record<string, string> = {};

    paramsToTrack.forEach((key) => {
      const value = searchParams.get(key);
      if (value) {
        propertiesToRegister[key] = value;
      }
    });

    // If we found any params, register them as super properties
    if (Object.keys(propertiesToRegister).length > 0) {
      // Wait for PostHog to be ready before registering
      const registerParams = () => {
        if (posthog?.__loaded) {
          posthog.register(propertiesToRegister);
          // Capture an event so we can verify it's working
          posthog.capture("referrer_tracked", propertiesToRegister);
          console.log("referrer_tracked", propertiesToRegister);
          hasRegistered.current = true;
          console.log("PostHog registered params:", propertiesToRegister);
        } else {
          // PostHog not ready yet, retry in 100ms
          setTimeout(registerParams, 100);
        }
      };

      registerParams();
    }
  }, [searchParams, posthog]);

  return null;
};
